import React from 'react';

const Section = (props) =>{
    const {color,background,id,layout,prechildren,children} = props;
    return (
        <section className={(color || 'white') +((background) ? " " + background : "" ) + " " +  props.className} id={id}>
            {prechildren}
            <div className={layout || 'container'}>
                {children}
            </div>
        </section>
    );
}

export default Section;